var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"captcha-widget mb-1 d-flex",staticStyle:{"margin-left":"37px"},attrs:{"id":"captcha-container"}},[_c('div',{staticClass:"cf-turnstile",attrs:{"id":"turnstile-widget","data-sitekey":_vm.CAPTCHA_SITE_CODE,"data-callback":"onCaptchaSuccess"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }